import { Link as Base } from "@remix-run/react";

export default (props: any) => {
  return <Base {...props} />;
};
